import { Button } from '../../components/ui/button';
import { useAdminActivity } from '../../hooks/use-admin-activity';
import { AdminActivityList } from './admin-activity-list';

export function AdminActivitySection() {
  const { data, isLoading, isError, error, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useAdminActivity();
  const activities = data?.pages.flatMap((page) => page.activities) ?? [];

  if (isLoading) {
    return <p className="text-sm text-text-tertiary">Laster hendelser…</p>;
  }

  if (isError && activities.length === 0) {
    return (
      <p className="rounded-md bg-danger/8 px-3 py-2 text-xs text-danger/80">
        Kunne ikke laste hendelser: {error.message}
      </p>
    );
  }

  return (
    <div className="space-y-3">
      <AdminActivityList activities={activities} />
      {isError && (
        <p className="rounded-md bg-danger/8 px-3 py-2 text-xs text-danger/80">
          Kunne ikke laste flere hendelser: {error.message}
        </p>
      )}
      {hasNextPage && (
        <Button
          variant="outline"
          className="w-full"
          disabled={isFetchingNextPage}
          onClick={() => void fetchNextPage()}
        >
          {isFetchingNextPage ? 'Laster flere…' : 'Vis flere'}
        </Button>
      )}
    </div>
  );
}
